/**
 * Context-aware auth token store. In a regular session the encrypted Firebase
 * ID token lives in a cookie (so the server reads it from req.cookies.token).
 * In an impersonation tab the same encrypted token lives in sessionStorage
 * (so it never leaks across tabs and never collides with the admin's cookie),
 * and callAPI sends it as Authorization: Bearer.
 *
 * Use these helpers anywhere you'd otherwise call TokenCookieManager directly
 * inside auth flows that must support both regular and impersonation contexts.
 */

import { TokenCookieManager } from './tokenCookies';
import {
  shouldUseImpersonationAuth,
  updateImpersonationToken,
  getImpersonationToken,
} from './impersonation.utils';

export const writeAuthToken = (encryptedToken: string): void => {
  if (shouldUseImpersonationAuth()) {
    updateImpersonationToken(encryptedToken);
  } else {
    TokenCookieManager.setToken(encryptedToken);
  }
};

export const readAuthToken = (): string | undefined | null => {
  if (shouldUseImpersonationAuth()) {
    return getImpersonationToken();
  }
  return TokenCookieManager.getToken();
};
